import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Accordion } from 'semantic-ui-react';

import { itemPropType } from './AccordionNavigationMenu.types';
import { AccordionNavigationMenuChild } from './components';

import './AccordionNavigationMenu.scss';

const propTypes = {
  items: PropTypes.arrayOf(itemPropType).isRequired,
  onSelectItem: PropTypes.func.isRequired,
  openItemIds: PropTypes.arrayOf(PropTypes.string),
  highlightedItemIds: PropTypes.arrayOf(PropTypes.string),
  folderIcon: PropTypes.string,
  fileIcon: PropTypes.string,
};

const defaultProps = {
  openItemIds: [],
  highlightedItemIds: [],
  folderIcon: 'caret right',
  fileIcon: 'file outline',
};

function AccordionNavigationMenu({
  items,
  onSelectItem,
  openItemIds: initialOpenItemIds,
  highlightedItemIds,
  folderIcon,
  fileIcon,
}) {
  const [openItemIds, setOpenItemIds] = useState(initialOpenItemIds);

  function onSelectFolder(folderId) {
    setOpenItemIds((prevOpenItemIds) => {
      if (prevOpenItemIds.includes(folderId)) {
        return prevOpenItemIds.filter((id) => id !== folderId);
      }

      return [...prevOpenItemIds, folderId];
    });
  }

  useEffect(() => {
    setOpenItemIds(initialOpenItemIds);
  }, [initialOpenItemIds]);

  return (
    <Accordion className="accordion-navigation-menu" styled>
      {items.map((item) => (
        <AccordionNavigationMenuChild
          key={item.id}
          item={item}
          openItemIds={openItemIds}
          onSelectFolder={onSelectFolder}
          onSelectItem={onSelectItem}
          highlightedItemIds={highlightedItemIds}
          folderIcon={folderIcon}
          fileIcon={fileIcon}
        />
      ))}
    </Accordion>
  );
}

AccordionNavigationMenu.propTypes = propTypes;
AccordionNavigationMenu.defaultProps = defaultProps;

export default AccordionNavigationMenu;
